module.exports = __webpack_public_path__ + "img/safe-bg.e05353dd.png";